/* eslint default-param-last: 0 */
const INIT_STATE = {};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case 'SET_CURRENT_SELECTED_ORGANIZATION':
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
